import React from "react";

import { Skeleton } from "@packages/ds";

import * as S from "./style";

const items = [1, 2, 3, 4];
const ItemSkeleton = () => {
  return (
    <S.SkeletonWrapper>
      <div className="app-skeleton">
        <Skeleton synchronize>
          <S.Box width={24} height={12} />
        </Skeleton>
      </div>
      {items.map(i => (
        <Skeleton synchronize key={i}>
          <S.ServiceSkeleton>
            <div className="skeleton-boxes">
              <S.Box width={24} />
              <S.Box width={110} />
            </div>
            <S.Box width={110} />
          </S.ServiceSkeleton>
        </Skeleton>
      ))}
    </S.SkeletonWrapper>
  );
};
export default ItemSkeleton;
